/* Global import */
import {observable, decorate, action} from 'mobx';
import Api from "../../util/api";

/* Custom import */



export default class MouvStore{

    mouvements = observable([]);
    currentPage = 0;
    lastPage = 1;
    limit = 15
    search = ""

    constructor(rootStore, stockStore) {
        this.rootStore = rootStore
        this.stockStore = stockStore;
        this.api = new Api();
    }




    async getMouv()  {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            const authResponse = await this.api.mouvs.getMouv(this.limit, this.currentPage, this.search);

            if(this.mouvements.length > 0) {
                this.mouvements.replace(authResponse.data)
            } else {
                this.mouvements = authResponse.data;
            }

            this.currentPage = authResponse.currentPage;
            this.lastPage = authResponse.lastPage;
            this.rootStore.savedDatasStore.setLoading(false)

        } catch(e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }

    async saveMouv(data)  {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            const authResponse = await this.api.mouvs.saveMouv(data)

            if(authResponse?.status  === "success") {
                this.rootStore.savedDatasStore.setLoading(false)
                this.rootStore.notificationStore.setNotification("Ajout mouvement de stock", "success");
            }

            return authResponse.status

        } catch(e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }

    async inventaire(data)  {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            const authResponse = await this.api.mouvs.inventaire(data)

            if(authResponse?.status  === "success") {
                this.rootStore.savedDatasStore.setLoading(false)
                this.rootStore.notificationStore.setNotification("Ajout mouvement de stock", "success");
            }

            return authResponse.status

        } catch(e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }

    async corrigerMouv(id, reason)  {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            const authResponse = await this.api.mouvs.corrigerMouv(id, reason)

            if(authResponse?.status  === "success") {
                this.rootStore.notificationStore.setNotification("Mouvement #" + id + " corrigé", "success");
            }

            this.rootStore.savedDatasStore.setLoading(false)

            return authResponse?.status

        } catch(e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }
}


decorate(MouvStore, {
    mouvements: observable,
    getMouv: action,
    currentPage: observable,
    lastPage: observable,
    limit: observable,
    search: observable
});